import { useCallback } from "react";
import { atom, useAtom } from "jotai";
import { Challenge } from "@nestcoinco/hyper-api-gateway-api-client";

const isChallengeListModalOpenAtom = atom(false);
const isChallengeResponseModalOpenAtom = atom(false);

export function useIsChallengeListModalOpen() {
  const [isChallengeListModalOpen, setIsChallengeListModalOpen] = useAtom(
    isChallengeListModalOpenAtom
  );

  const openChallengeListModal = useCallback(
    () => setIsChallengeListModalOpen(true),
    [setIsChallengeListModalOpen]
  );
  const closeChallengeListModal = useCallback(
    () => setIsChallengeListModalOpen(false),
    [setIsChallengeListModalOpen]
  );

  return {
    openChallengeListModal,
    closeChallengeListModal,
    isChallengeListModalOpen,
  };
}

export function useIsChallengeResponseModalOpen() {
  const [isChallengeResponseModalOpen, setIsChallengeResponseModalOpen] =
    useAtom(isChallengeResponseModalOpenAtom);

  const openChallengeResponseModal = useCallback(
    () => setIsChallengeResponseModalOpen(true),
    [setIsChallengeResponseModalOpen]
  );
  const closeChallengeResponseModal = useCallback(
    () => setIsChallengeResponseModalOpen(false),
    [setIsChallengeResponseModalOpen]
  );

  return {
    openChallengeResponseModal,
    closeChallengeResponseModal,
    isChallengeResponseModalOpen,
  };
}

export const selectedChallengeResponseAtom = atom<{
  isDecline?: boolean;
  challenge?: Challenge;
}>({});
